
<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="800px" transition="dialog-transition">
    <v-card>
      <v-card-title>
        <span class="headline">Editando endereço do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-col cols='12'>

          <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
          <h3> Endereço de faturamento </h3>
          <AddressForm :validate_form="true" ref="address" :address="address"></AddressForm>

        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate"></f-btn>
      </v-card-actions>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import validations from '@/mixins/validations'
import getters from "@/_backoffice/_registrations/mixins/getters.js"
import Api from '@/api/index'

export default {
  name: 'ClientEditAddressDialog',
  mixins:[ validations, getters ],
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
  },
  components:{
    AddressForm: () => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  data() {
    return {
      dialog: false,
      address: {
        addressable_id: this.$route.params.id,
        addressable_type: 'Client',
        zip: null, 
        addr: null, 
        complement: null, 
        neighborhood: null, 
        city: null, 
        state: null, 
        number: null, 
        id: null,
      },
      saving: false,
    }
  },
  methods: {
    setAddress(){

    },
    emitUpdate(){
      if(this.$refs.address.validate()){
        let success = false
        this.saving = true
        let METHOD = this.address.id ? 'update' : 'create'
        Api.Address[METHOD](this.address).then(r=>{
          success = true
        }).catch((err)=>{
          console.log(err)
        }).finally(() => {
          this.saving = false
          if(success){
            this.$emit('clientAddress')
          }
        })
      }
      // this.$emit('update', {new_client: this.new_client, model: 'address'})
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed:{
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv, old) {
      if (nv) {
        if(this.oneClient?.data?.attributes?.address?.data?.length > 0){
          var { id, zip, addr, complement, neighborhood, city, state, number } = this.oneClient?.data?.attributes?.address.data[0].attributes
          var obj = {
            id: id,
            zip: zip,
            addr: addr,
            complement: complement,
            neighborhood: neighborhood,
            city: city,
            state: state,
            number: number,
          }
          this.address = {...this.address, ...obj}
        } 
      }
    },
  },
  mounted () {
    this.setAddress();
  },
}
</script>
